module.exports = __webpack_public_path__ + "img/1535675148.34fcf7e9.jpg";